import React from "react";

const Heading = ({ block, last }) => {
  const Tag = `h${block.size === 1 ? 2 : block.size}`;
  return (
    <section>
      <div className="shell">
        <div className="prose max-w-none">
          <Tag className={`${block.size === 1 ? "text-lg" : ""}${!last ? " mb-8" : ""}`}>
            {block.text}
          </Tag>
        </div>
      </div>
    </section>
  );
}

export default Heading;